/** Says check-ins save as they happen, and where closing returns to. */
export function CheckInFooter({ onClose, returnsTo }: { onClose: () => void; returnsTo: string }) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 12,
        paddingTop: 4,
      }}
    >
      <span style={{ fontSize: 11.5, color: 'var(--nb-subtle)' }}>
        Saved live — close anytime to return to {returnsTo}.
      </span>
      <button type="button" className="nb-btn nb-btn-primary" onClick={onClose}>
        Done
      </button>
    </div>
  );
}
